export default "__VITE_ASSET__CdefkaNw__"